import React from 'react';
import { withStyles, withTheme } from '@material-ui/styles';

const useStyles = theme => ({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) scale(4)",
    zIndex: 9999
  },
  circularLoader: {
    scale: 1,
    animation: '$isRotating 1s infinite',
    borderRadius: '50%',
    width: '15px',
    height: '15px',
    border: '1.5px solid #e5e5e5',
    borderTopColor: theme.palette.background.iconContrastSecondary,
  },
  loaderText: {
    color: '#1351b4',
    fontSize: '14px'
  },
  '@keyframes isRotating': {
    to: {
      transform: 'rotate(1turn)',
    },
  }
});


const LoadingCircular = props => {

  let { classes } = props;

  return (
    <div id="circularLoader" className={classes.main}>
      <div className={classes.circularLoader}></div>
    </div>
  )
}

export default (withStyles(useStyles)(withTheme(LoadingCircular)));
